module.exports = __webpack_public_path__ + "fonts/ralewaybolditalic.316f503.woff2";